<template>
    <div class="greeting-box">
      <div class="greet">
          <div class="greeting">
            <div class="heading fw-bold mb-1">"{{ pagecontent.home.homeHeading }}"</div>
            <div class="body">{{ pagecontent.home.homeDescription }}</div>
        </div>
        <div class="actions mt-3">
          <div class="action"><router-link class="btn btn-default learnmore" to="/about">Learn More</router-link></div>
          <div class="action"><router-link class="btn btn-default signup" to="/signup">Sign Up</router-link></div>
        </div>
      </div>      
    </div>
</template>
<script>
    import pagecontent from '../assets/text.json'
export default {
    data() {
    return {
      pagecontent
    }
  }
}
</script>
<style scoped>
    .learnmore{
    background-color: var(--primary);
    color:white;
  }

  .signup{
    border:1px solid var(--primary);
    color:var(--primary);
    background: transparent;
  }


  .heading{
    color:var(--primary);
    font-style: italic;
    font-size:2rem;
    
  }

  .greet{
    display: flex;
    flex-direction: column;
    grid-column:2/3;
  }
  
  
  .greeting{
    flex:1.4;
  }
  
  .greeting-box{
     /* border:1px red solid; */
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
     border-bottom:1px solid var(--lightgrey);
    padding-bottom:1.5rem;
    
  }

 

  .actions{
    display: flex;
    column-gap: 0.5rem;
  }

  .body{
    font-size: 1.4rem;
  }

  

  @media(max-width:768px){
     .greet{
      grid-column:1/4;

    }

  .body{
    font-size: 1rem;
  }

  .heading{
    color:var(--primary);
    font-style: italic;
    font-size:var(--title);
    
  }
  }
</style>